export namespace BacklogsHubTelemetryConstants {
    export const PivotKey = "Pivot";
    export const LEVEL_CHANGE = "Backlogs.LevelChange";
    export const BACKLOGS_START_LOADCONTENTVIEW = "Backlogs_Start_LoadContentView";
    export const BACKLOGS_START_LOADDIRECTORYVIEW = "Backlogs_Start_LoadDirectoryView";
    export const SEARCH_TEAM = "Backlogs_Search_Team";
    export const NAVIGATE_TO_DIRECTORY = "Backlogs_ArtifactPicker_NavigateDirectory"
    export const VIEW_HUB_TILE_REGION = "Backlogs_View_Hub_Tile_Region";
    export const CLICK_TRYOUT_ANALYTICSPIVOT = "Backlogs_TryOutAnalyticsPivot";

    // Mapping
    export const MAPPING_OPENED = "Mapping_Opened";
    export const MAPPING_CLOSED = "Mapping_Closed";
    export const MAPPING_ITEM_DROPPED = "Mapping_Item_Dropped";
    export const MAPPING_WORKITEMIDS_LOADED = "Mapping_WorkItemIds_Loaded";
    export const MAPPING_WORKITEMS_PAGED = "Mapping_WorkItems_Paged";
    export const MAPPING_TEAM_SELECTED = "Mapping_Team_Selected";

    // Mapping Perf
    export const MAPPING_INITIAL_LOAD = "Mapping_Initial_Load";
    export const IdsLoadedSplit = "IdsLoaded";

    export const ItemCount = "ItemCount";
    export const SameTeam = "SameTeam";

    // Planning
    export const PLANNING_OPENED = "Planning_Opened";
    export const PLANNING_CLOSED = "Planning_Closed";
    export const PLANNING_ITEM_DROPPED = "Planning_ItemDropped";
    export const PLANNING_ITEM_DROPPED_BACKLOG = "Planning_ItemDropped_Backlog";
    export const PLANNING_NEW_SPRINT_OPENED = "Planning_NewSprint_Opened";
    export const PLANNING_NAVIGATE_TO_ITERATION = "Planning_Navigate_To_Iteration";
    export const PLANNING_NAVIGATE_TO_BACKLOG = "Planning_Navigate_To_Backlog";

    // Planning Perf
    export const PLANNING_INITIAL_LOAD = "Planning_Initial_Load";
    export const IterationCount = "IterationCount";
    export const BucketLoadedSplit = "BucketLoaded";

    //  Commands usage.
    export const SWITCH_TO_MATCHING_BOARD = "SwitchToMatchingBoard";

    export const ZERO_DATA_ADD_NEW_ITEM = "BacklogsHub_Backlog_ZeroDataAddNewItem";

    // parent column
    export const PARENT_COLUMN_ADDED = "BacklogsHub_Backlog_ParentColumn_Added";
    export const PARENT_COLUMN_REMOVED = "BacklogsHub_Backlog_ParentColumn_Removed";
    export const BacklogLevel = "BacklogLevel";

    // Show/hide completed child items usage.
    export const COMPLETED_CHILD_ITEMS_TOGGLED = "ShowCompletedChildItems_Button_Toggled_To";
    export const COMPLETED_CHILD_ITEMS_LOADED_AS = "ShowCompletedChildItems_Loaded_As";

    // Rollup column banner
    export const ROLLUP_BANNER_DISPLAYED = "RollupBannerDisplayed";
    export const IsRequirementBacklog = "isRequirementBacklog";
}